import { connect } from 'react-redux';
import { clearApplicationError } from '../../actions/aplication_error';
import { displayRegister } from '../../actions/auth';

import RoutesComponent from './routes';

const mapStateToProps = ({
  chat, applicationError, voipChat, user
}) => ({
  ...chat, ...applicationError, voipState: voipChat.voipState, user: user?.user
});

export default connect(
  mapStateToProps,
  { clearApplicationError, displayRegister }
)(RoutesComponent);
